import { Component, computed, inject, ViewEncapsulation } from "@angular/core";
import { NzLayoutModule } from "ng-zorro-antd/layout";
import { NzIconModule } from "ng-zorro-antd/icon";
import { NzMenuModule } from "ng-zorro-antd/menu";
import { Router, RouterLink, RouterOutlet } from "@angular/router";

@Component({
  selector: "app-aws-utilities",
  imports: [NzLayoutModule, NzIconModule, NzMenuModule, RouterOutlet, RouterLink],
  templateUrl: "./aws-utilities.component.html",
  styleUrl: "./aws-utilities.component.less",
  encapsulation: ViewEncapsulation.ShadowDom
})
export class AwsUtilitiesComponent {
}
